export default "__VITE_ASSET__Dxtq1p8A__"